import React from 'react';
import Class9Fieldtrip2024 from 'views/Class9Fieldtrip2024';

const VissionAndMissionPage = () => {
  return <Class9Fieldtrip2024/>;
};

export default VissionAndMissionPage;